import { render, staticRenderFns } from "./MemberTypeSelectNew.vue?vue&type=template&id=71589452&scoped=true&"
import script from "./MemberTypeSelectNew.vue?vue&type=script&lang=js&"
export * from "./MemberTypeSelectNew.vue?vue&type=script&lang=js&"
import style0 from "./MemberTypeSelectNew.vue?vue&type=style&index=0&id=71589452&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71589452",
  null
  
)

export default component.exports